import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const ReportBuilderWorkflowRoute: RouteType = {
  name: "Report Builder Workflow",
  path: "/workflows/report-builder",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Custom Report Builder",
      component: () => import("./ReportBuilderWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ReportBuilderWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const apiServicesStore = rootStore.apiServicesStore as ServiceStore;
      const bidAnalyticsStore = rootStore.bidAnalyticsStore as ServiceStore;
      const financialReportsStore = rootStore.financialReportsStore as ServiceStore;

      await Promise.all([
        apiServicesStore?.find(),
        bidAnalyticsStore?.find(),
        financialReportsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for report builder:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).reportBuilderWorkflowStore;
    store?.reset();
  },
};

export default ReportBuilderWorkflowRoute;